export enum DeploymentStep {
  Done = 0,
  Selection = 1,
  Validation = 2,
  Preview = 3,
  Deployment = 4
}
